module.exports = __webpack_public_path__ + "img/22_18.026a99c6.png";